import API from './API.js'
import axios from 'axios'

export default class Attendance extends API {
  constructor() {
    super('attendance')
  }

  async getAttendanceByDate(params) {
    try {
      const response = await axios.get('/get_attendance_by_date', { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message)
      }
    }
  }
}
